export const isRequired = (fieldName) => `${fieldName} is required`

export const mustMatch = (otherFieldName) => (fieldName) =>
  `${fieldName} must match ${otherFieldName}`

export const minLength = (length, absoluteLength) => (fieldName) =>
  absoluteLength
    ? `${fieldName} must be ${length} characters long`
    : `${fieldName} must be at least ${length} characters`

export const validDate = (fieldName) => `${fieldName} is invalid`

export const validNumbers = (fieldName) =>
  `${fieldName} contains invalid characters`

export const invalidSAT = () => `Invalid SAT score`

export const invalidGPA = () => `Invalid GPA score`

export const maxLength = (length) => (fieldName) =>
  `${fieldName} must be at most ${length} characters`

export const matchesRegExp = (fieldName) => `${fieldName} is invalid`

export const invalidEmail = (fieldName) => `${fieldName} is not valid` // fieldName will always be XYZ email.

export const invalidUrl = (fieldName) => `${fieldName} is not a valid URL`
